import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/bim360-matrix-react-button';
import { TSymbolProp, withLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MDText } from 'i18n-react';

class TreeLoadMoreNode extends React.PureComponent {
  render() {
    return (
      <Button
        styleType={Button.StyleType.INLINE_LINK}
        className="TreeNode TreeNode__load-more-node"
        onClick={this.props.onLoadMore}
        data-testid={this.props.dataTestid}
      >
        {this.props.loadMoreText || this.props[TSymbolProp].translate('LOAD_MORE')}
      </Button>
    );
  }
}

TreeLoadMoreNode.propTypes = {
  onLoadMore: PropTypes.func.isRequired,
  loadMoreText: PropTypes.string,
  dataTestid: PropTypes.string
};

export default TreeLoadMoreNode;
export const TreeLoadMoreNodeWithLocale = withLocale(
  TreeLoadMoreNode,
  ({ locale }) => new MDText(require(`./i18n/${locale}.json`))
);
